module.exports = __webpack_public_path__ + "./assets/6dc1222fc6e1961fa5ae8e9f72af7912.woff";